@for (group of output; track group) {
  <drag-and-drop-group [displayProperty]="displayProperty" [items]="group.Items" [title]="group.Title">
  </drag-and-drop-group>
}
